var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-message',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.messageContent)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }